<template>
  <div :class="['form-element', hidden && 'd-none']">
    <div class="d-flex">
      <FormSubjectCodeSelect
        v-model="tempValue.subjectCode"
        class="flex-1 mr-1"
        :disabled="disabled"
        @input="validate"
      />
      <div class="flex-1 mr-1 d-flex">
        <FormText
          v-model="tempValue.courseNumber"
          v-tooltip.bottom="{
            content: 'This course code is already in use',
            show: isError,
            trigger: 'manual',
            classes: 'tooltip-danger',
            boundariesElement: 'body',
          }"
          :placeholder="disabled ? '—' : placeholder"
          :disabled="disabled"
          :inline="inline"
          :class="['flex-1', isError && 'is-invalid']"
          @input="validate"
        />
        <AppButton v-if="isChecking" class="px-1 py-0">
          <AppIcon name="cached" :size="16" class="icon-align spin" />
        </AppButton>
        <AppButton
          v-else
          variant="danger"
          class="px-1 py-0"
          @click="$emit('deleting')"
        >
          <AppIcon name="delete" />
        </AppButton>
      </div>
    </div>
  </div>
</template>

<script>
import { inject, ref } from '@vue/composition-api'
import FormMixin from './FormMixin'
import FormSubjectCodeSelect from './Variations/subjectCodeSelect'
import FormText from './FormText'
import _debounce from 'lodash/debounce'
import { DEBOUNCE_INTERVAL } from '@/constants/'
import { getCmCourseNumberValidation } from '@/api'
import { mapGetters } from 'vuex'
import _clonedeep from 'lodash/cloneDeep'

export default {
  mixins: [ FormMixin ],
  components: { FormSubjectCodeSelect, FormText },
  props: {
    inline: {
      type: Boolean,
      default: false,
    },
    aliases: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      isSuccess: false,
      isError: false,
      isChecking: false,
      tempValue: {},
    }
  },
  setup () {
    // TODO: Get rid of this inject and use only formValue at some point
    const providerData = inject('providerData', ref({
      questions: {},
      values: {},
      courseId: '',
    }))
    const courseId = inject('courseId', ref(''))

    return {
      providerData,
      courseId,
    }
  },
  computed: { ...mapGetters([ 'school' ]) },
  watch: {
    aliases () {
      this.isError = !this.isError
      this.isError = !this.isError
    },
  },
  created () {
    this.tempValue = _clonedeep(this.value)
  },
  methods: {
    validate () {
      this.isChecking = true
      this.isSuccess = false
      this.isError = false
      this.validatingDebounced()
    },
    validatingDebounced: _debounce(function () {
      this.validateCourseNumber()
    }, DEBOUNCE_INTERVAL),
    async validateCourseNumber () {
      if (this.tempValue.subjectCode && this.tempValue.courseNumber) {
        const { status } = await getCmCourseNumberValidation({
          school: this.school,
          ...this.tempValue,
          courseId: this.courseId || this.providerData.courseId,
        })
        this.isSuccess = status === 'valid'
        this.isError = !this.isSuccess
        if (this.isSuccess && status) {
          this.$emit('input', this.tempValue)
        }
      }
      this.isChecking = false
    },
  },
}
</script>

<style scoped>
.form-control {
  height: 36px;
}

.form-text--inline:not(:focus):not(:hover) {
  border-color: transparent;
  background-color: transparent;
}
.icon-align {
  line-height: 12px;
}
.spin {
  animation: spin 2000ms infinite linear;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
